export enum ResponseUser {
    UNCONFIRMED = 'UserNotConfirmed',
    OK = 'OK',
    CHANGEPASSWORD = 'ChangePassword',
    USERFEDERATEACCOUNT = 'UserFederatedAccount'
}
